export default __webpack_public_path__ + "static/media/GLTD.dde3f53b.png";